import { type ReactElement } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { PageTitle } from './PageTitle'

interface RouteConfig {
  path: string
  fullPath?: string
  pageTitle?: string
}

interface RouteWithTitleProps {
  children: ReactElement
  routeConfigs: Record<string, RouteConfig>
}

export const RouteWithTitle = ({
  children,
  routeConfigs,
}: RouteWithTitleProps) => {
  const location = useLocation()

  // Find matching route
  const findMatchingRoute = () => {
    for (const config of Object.values(routeConfigs)) {
      // Use fullPath for matching if available, otherwise use path
      const pathToMatch = config.fullPath || config.path
      const match = matchPath({ path: pathToMatch }, location.pathname)
      if (match && config.pageTitle) {
        return config.pageTitle
      }
    }
    return null
  }

  const pageTitle = findMatchingRoute()

  return (
    <>
      <PageTitle title={pageTitle} />
      {children}
    </>
  )
}
